import { createScreenStyles } from '../../theme/styles';
import { OPERATIONS_API_BASE } from '../../config/api';
import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, Dimensions, ScrollView, TouchableHighlight} from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';
import { FontAwesome } from '@expo/vector-icons'; 

const screenWidth = Math.round(Dimensions.get('window').width);
const screenHeight = Math.round(Dimensions.get('window').height);



const preIndex = ( {route, navigation} ) => {

  const [count, setCount] = useState("");
  const [loading, setLoading] = useState(false);

  const { type } = route.params;

  async function loadCounts() {
    //0 = Entrada 
    //1 = Saída

    let apiUrl = '';
    if(type === 0){
      apiUrl = `${OPERATIONS_API_BASE}/checklistcomp/countDocs`;
    } else {
      apiUrl = `${OPERATIONS_API_BASE}/checklistcomp/count/docs/exit`;
    }

    const response = await fetch(
      apiUrl
    );

    const data = await response.json();
    setCount(data);
    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    loadCounts();
  }, []);

  return (
  
        <ScrollView style={styles.content}>
          

          <View style={styles.row}>

            <TouchableHighlight underlayColor={"transparent"} onPress={() => { type === 0 ? navigation.navigate('Compressor', { status: 0, type: 0 }) :  navigation.navigate('Compressor', { status: 0, type : 1 })}}>
              <View style={styles.menuItem}>                  
                <FontAwesome name="mobile" size={45} color="#00004C" /> 
                <Text style={styles.textMenu}>Pendente ({count.totalRecords0})</Text>
              </View>
            </TouchableHighlight>


            <TouchableHighlight underlayColor={"transparent"} onPress={() => { type === 0 ? navigation.navigate('Compressor', { status: 1, type: 0 }) :  navigation.navigate('Compressor', { status: 1, type : 1 })}}>
              <View style={styles.menuItem}>                
                <FontAwesome5 name="comment" size={36} color="#00004C" /> 
                <Text style={styles.textMenu}>Em Avalição ({count.totalRecords1})</Text>
              </View>
            </TouchableHighlight>
   
            <TouchableHighlight underlayColor={"transparent"} onPress={() => { type === 0 ? navigation.navigate('Compressor', { status: 2, type: 0 }) :  navigation.navigate('Compressor', { status: 2, type : 1 })}}>
              <View style={styles.menuItem}>                
                <FontAwesome name="check" size={36} color="#00004C" /> 
                <Text style={styles.textMenu}>Finalizados ({count.totalRecords2})</Text>
              </View>
            </TouchableHighlight>

          </View>



        </ScrollView>


    );
}

var styles = createScreenStyles({


  backImageHeader: {
    width: '100%'
  },

  content: {
    paddingHorizontal: 16
  },

  contentContainer: {
    height:'100%',
    backgroundColor: '#f3f3f3',

  },


  menuItem:{
    width: '100%',
    minHeight: 124, paddingVertical: 20,
    marginBottom:20,
    flex:1,
    backgroundColor: '#fff',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius:10,
    shadowColor: "#000",
    shadowOffset: {
      width: 8,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 3.49,
    elevation: 12,
  },

  textMenu: {
    fontSize:16,
    paddingTop:10,
    color: '#003c84',
    textAlign:'center'
  },

  row:{
    marginTop:20,
  }
});

export default preIndex;